import { AppointmentPDF } from '@avanta/shared/components/AppointmentPDF';
import { Button } from '@avanta/shared/components/ui/Button';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { useFetchPatient } from '@avanta/shared/hooks/useFetchPatient';
import { t } from '@avanta/shared/i18n';
import { openPDF } from '@avanta/shared/utils/storage';
import { File } from 'lucide-react';
import { type DownloadAppointmentPDFProps } from './types';

export const DownloadAppointmentPDF = ({
  appointment,
  icon,
  buttonLabel = t('DownloadAppointmentPDF.cta', { ns: LOCIZE_NS.APPOINTMENTS }),
  className,
}: DownloadAppointmentPDFProps): React.ReactElement | null => {
  const { data: patient } = useFetchPatient(appointment.patientId);

  if (!patient) return null;

  const handleDownloadAppointmentPdf = async (): Promise<void> => {
    openPDF({
      pdfComponent: (
        <AppointmentPDF appointment={appointment} patient={patient} mode="enterprise" />
      ),
      filename: appointment.dateTime,
    });
  };

  return (
    <Button
      variant="link"
      icon="leading"
      className={className}
      onClick={handleDownloadAppointmentPdf}
    >
      <File className="size-4" />
      {icon !== 'only' && buttonLabel}
    </Button>
  );
};
